import { ButtonSize, ButtonVariants } from '@anm/components/buttons/Button';
import noop from '@anm/helpers/noop';
import { useEffect, useState, FC } from 'react';

import Avatar from '../Avatar';
import InputFile, { UploadFileProps } from '../InputFile';
import ButtonLoader from '../buttons/ButtonLoader';

import Message from './Message';
import Wrapper, { Container } from './Wrapper';

export type UploadAvatarData = { file: File; objectUrl: string };
export type AvatarUploadVariant = 'inline';
export type AvatarUploadProps = {
  preview: string;
  onUpload?: (data: UploadAvatarData) => void;
  buttonVariant?: ButtonVariants;
  buttonSize?: ButtonSize;
  className?: string;
  variant?: AvatarUploadVariant;
  showMessage?: boolean;
  buttonTitle?: string;
};

const usePreview = (defaultPreview: string) => {
  const state = useState(defaultPreview);
  const setPreview = state[1];

  useEffect(() => {
    setPreview(defaultPreview);
  }, [defaultPreview]);

  return state;
};

const AvatarUpload: FC<AvatarUploadProps> = ({
  onUpload = noop,
  preview: defaultPreview,
  className,
  variant,
  showMessage = 'true',
  buttonVariant = 'blue-heavy-border',
  buttonSize = 'large_long_static',
  buttonTitle = 'Choose image'
}) => {
  const [isPending, setIsPending] = useState(false);
  const [isLarge, setIsLarge] = useState(false);
  const [preview, setPreview] = usePreview(defaultPreview);

  const handleFileChange = (props: UploadFileProps[]) => {
    const { file, objectUrl } = props[0];
    const isFileLarge = file.size > 500 * 1000;
    setIsLarge(isFileLarge);

    if (isFileLarge) return;

    setIsPending(true);
    setPreview(objectUrl);

    try {
      onUpload({ file, objectUrl });
    } finally {
      setIsPending(false);
    }
  };

  return (
    <Wrapper className={className} variant={variant}>
      <Avatar src={preview} size={variant === 'inline' ? 50 : 100} />
      <Container>
        <label>
          <InputFile handleUpload={handleFileChange} accept={['.jpg', '.jpeg', '.png'].join()} />
          <ButtonLoader buttonType="container" size={buttonSize} variant={buttonVariant} isPending={isPending}>
            {buttonTitle}
          </ButtonLoader>
        </label>
        {showMessage && <Message isLarge={isLarge} />}
      </Container>
    </Wrapper>
  );
};
export default AvatarUpload;
